/*!
 * Your Design, Your Sign — acrylic.studio
 * Upload → size → aspect-locked crop (Cropper.js 1.6) → live acrylic wall preview →
 * export JPEG → attach as file line-item property → multipart POST to /cart/add.js → /cart
 */
(function () {
  'use strict';

  var CROPPER_FALLBACK_JS = 'https://cdn.jsdelivr.net/npm/cropperjs@1.6.2/dist/cropper.min.js';
  var HEIC2ANY_JS = 'https://cdn.jsdelivr.net/npm/heic2any@0.0.4/dist/heic2any.min.js';
  var MAX_UPLOAD_BYTES = 19 * 1024 * 1024; // stay under Shopify's ~20 MB line-item file limit
  var TARGET_EXPORT_DPI = 150;               // export goal at the chosen print size (40x60 -> 6000x9000)
  var DESKTOP_MAX_SIDE = 9000;               // hard ceiling on desktop (~54 MP at 2:3)
  var MOBILE_MAX_PIXELS = 16777216;          // 4096*4096: iOS Safari canvas area limit (~16.7 MP)
  var MOBILE_PLAN_PIXELS = 16760000;         // plan slightly under it (Cropper may round a dimension up by 1 px)
  var QUALITY_STEPS = [0.92, 0.85, 0.78, 0.7];
  var RETRY_SCALE = 0.75;                    // canvas/toBlob failure -> retry at 75% size
  var MIN_EXPORT_SIDE = 800;                 // give up below this long side

  /** iPhone/iPod/iPad (incl. iPadOS that reports "Macintosh"), Android and other mobile/tablet browsers. */
  function isMobileCanvasDevice() {
    var nav = window.navigator || {}, ua = nav.userAgent || '';
    var touchPoints = nav.maxTouchPoints || 0;
    if (/iPhone|iPad|iPod/i.test(ua)) return true;
    if (/Macintosh/i.test(ua) && touchPoints > 1) return true; // iPadOS 13+ desktop-class UA
    if (nav.userAgentData && nav.userAgentData.mobile) return true;
    if (/Android|Mobi|Silk|Kindle|BlackBerry|BB10|Opera Mini|IEMobile|webOS/i.test(ua)) return true;
    try { // touch-only tablet with no fine pointer at all
      if (touchPoints > 0 && window.matchMedia && window.matchMedia('(pointer: coarse)').matches &&
          !window.matchMedia('(any-pointer: fine)').matches) return true;
    } catch (e) { /* noop */ }
    return false;
  }

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src; s.async = true;
      s.onload = resolve; s.onerror = function () { reject(new Error('Could not load ' + src)); };
      document.head.appendChild(s);
    });
  }

  function ensureCropper() {
    return window.Cropper ? Promise.resolve(window.Cropper) : loadScript(CROPPER_FALLBACK_JS).then(function () { return window.Cropper; });
  }

  /** "18 x 24" | "18x24" | "18 × 24 in" → {a:18, b:24} (as written) */
  function parseSize(str) {
    var m = String(str || '').match(/(\d+(?:\.\d+)?)\s*(?:x|×|X|by)\s*(\d+(?:\.\d+)?)/);
    return m ? { a: parseFloat(m[1]), b: parseFloat(m[2]) } : null;
  }

  function isHeic(file) {
    return /heic|heif/i.test(file.type || '') || /\.(heic|heif)$/i.test(file.name || '');
  }

  function loadImage(url) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.decoding = 'async';
      img.onload = function () { resolve(img); };
      img.onerror = function () { reject(new Error('decode')); };
      img.src = url;
    });
  }

  function canvasToBlob(canvas, type, quality) {
    return new Promise(function (resolve, reject) {
      if (canvas.toBlob) {
        canvas.toBlob(function (b) { b ? resolve(b) : reject(new Error('Export failed')); }, type, quality);
      } else {
        var bin = atob(canvas.toDataURL(type, quality).split(',')[1]);
        var arr = new Uint8Array(bin.length);
        for (var i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
        resolve(new Blob([arr], { type: type }));
      }
    });
  }

  function slug(s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }

  function CustomSign(root) {
    this.root = root;
    this.form = $('[data-cs-form]', root);
    this.minDpi = parseFloat(root.getAttribute('data-min-dpi')) || 100;
    this.goodDpi = parseFloat(root.getAttribute('data-good-dpi')) || 150;
    this.maxSide = Math.min(parseInt(root.getAttribute('data-max-side'), 10) || DESKTOP_MAX_SIDE, DESKTOP_MAX_SIDE);
    this.exportDpi = parseFloat(root.getAttribute('data-export-dpi')) || TARGET_EXPORT_DPI;
    this.mobileCanvas = isMobileCanvasDevice();
    this.quality = (parseFloat(root.getAttribute('data-quality')) || 92) / 100;
    this.cartUrl = root.getAttribute('data-cart-url') || '/cart';
    this.cartAddUrl = root.getAttribute('data-cart-add-url') || '/cart/add';

    this.el = {
      upload: $('[data-cs-upload]', root),
      drop: $('[data-cs-drop]', root),
      dropTitle: $('[data-cs-drop-title]', root),
      dropMeta: $('[data-cs-drop-meta]', root),
      sizes: $$('[data-cs-size]', root),
      orient: $$('[data-cs-orient]', root),
      editor: $('[data-cs-editor]', root),
      cropImg: $('[data-cs-crop-img]', root),
      zoom: $('[data-cs-zoom]', root),
      reset: $('[data-cs-reset]', root),
      replace: $('[data-cs-replace]', root),
      quality: $('[data-cs-quality]', root),
      sign: $('[data-cs-sign]', root),
      preview: $('[data-cs-preview]', root),
      sizeTag: $('[data-cs-size-tag]', root),
      price: $('[data-cs-price]', root),
      variantId: $('[data-cs-variant-id]', root),
      file: $('[data-cs-file]', root),
      propSize: $('[data-cs-prop-size]', root),
      propFilename: $('[data-cs-prop-filename]', root),
      propDpi: $('[data-cs-prop-dpi]', root),
      propCrop: $('[data-cs-prop-crop]', root),
      submit: $('[data-cs-submit]', root),
      submitText: $('[data-cs-submit-text]', root),
      error: $('[data-cs-error]', root)
    };

    this.orientation = 'portrait';
    this.cropper = null;
    this.image = null;       // decoded source <img>
    this.objectUrl = null;
    this.fileName = '';
    this.baseRatio = 1;
    this.raf = 0;
    this.busy = false;

    this.selectedBtn = this.el.sizes.filter(function (b) { return b.classList.contains('is-selected'); })[0] ||
      this.el.sizes.filter(function (b) { return !b.disabled; })[0] || this.el.sizes[0];

    this.bind();
    this.applySize(false);
    this.updateSubmit();
  }

  CustomSign.prototype.bind = function () {
    var self = this, el = this.el;

    el.upload.addEventListener('change', function () {
      if (el.upload.files && el.upload.files[0]) self.loadFile(el.upload.files[0]);
    });

    ['dragenter', 'dragover'].forEach(function (t) {
      el.drop.addEventListener(t, function (e) { e.preventDefault(); e.stopPropagation(); el.drop.classList.add('is-over'); });
    });
    ['dragleave', 'dragend'].forEach(function (t) {
      el.drop.addEventListener(t, function () { el.drop.classList.remove('is-over'); });
    });
    el.drop.addEventListener('drop', function (e) {
      e.preventDefault(); e.stopPropagation();
      el.drop.classList.remove('is-over');
      var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (f) self.loadFile(f);
    });

    el.sizes.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        self.selectedBtn = btn;
        self.applySize(true);
      });
    });

    el.orient.forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.orientation = btn.getAttribute('data-cs-orient');
        el.orient.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-selected', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        self.applySize(true);
      });
    });

    if (el.zoom) {
      el.zoom.addEventListener('input', function () {
        if (self.cropper) self.cropper.zoomTo(self.baseRatio * parseFloat(el.zoom.value));
      });
    }
    if (el.reset) el.reset.addEventListener('click', function () { if (self.cropper) { self.cropper.reset(); self.syncZoom(); } });
    if (el.replace) el.replace.addEventListener('click', function () { el.upload.click(); });

    this.form.addEventListener('submit', function (e) { e.preventDefault(); self.addToCart(); });
  };

  /** Print dimensions (inches) for the selected size + orientation */
  CustomSign.prototype.printDims = function (btn) {
    var s = parseSize((btn || this.selectedBtn).getAttribute('data-size')) || { a: 3, b: 4 };
    var short = Math.min(s.a, s.b), long = Math.max(s.a, s.b);
    return this.orientation === 'landscape' ? { w: long, h: short } : { w: short, h: long };
  };

  CustomSign.prototype.aspect = function () { var d = this.printDims(); return d.w / d.h; };

  CustomSign.prototype.sizeLabel = function () {
    var d = this.printDims();
    return d.w + ' × ' + d.h + ' in';
  };

  CustomSign.prototype.applySize = function (userAction) {
    var el = this.el, btn = this.selectedBtn, d = this.printDims();
    el.sizes.forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    el.variantId.value = btn.getAttribute('data-variant-id');
    if (el.price) el.price.textContent = btn.getAttribute('data-price');
    if (el.sizeTag) el.sizeTag.textContent = this.sizeLabel();
    el.sign.style.setProperty('--cs-w', d.w);
    el.sign.style.setProperty('--cs-h', d.h);

    if (this.cropper) {
      this.cropper.setAspectRatio(this.aspect());
      this.syncZoom();
    }
    this.renderPreview();
    this.updateQuality();

    if (userAction && window.history && history.replaceState) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', el.variantId.value);
        history.replaceState(history.state, '', url.toString());
      } catch (e) { /* noop */ }
    }
  };

  CustomSign.prototype.setBusyDrop = function (on, title) {
    this.el.drop.classList.toggle('is-busy', !!on);
    if (title) this.el.dropTitle.textContent = title;
  };

  CustomSign.prototype.showError = function (msg) {
    this.el.error.textContent = msg || '';
    this.el.error.hidden = !msg;
  };

  CustomSign.prototype.loadFile = function (file) {
    var self = this;
    this.showError('');
    if (!file) return;
    if (!/^image\//i.test(file.type || '') && !isHeic(file) && !/\.(jpe?g|png|webp)$/i.test(file.name || '')) {
      this.showError('Please choose an image file (JPG, PNG or HEIC).');
      return;
    }
    this.setBusyDrop(true, 'Loading image…');

    var url = URL.createObjectURL(file);
    loadImage(url).catch(function () {
      URL.revokeObjectURL(url);
      if (!isHeic(file)) throw new Error('We couldn’t read that image. Try a JPG or PNG.');
      // Browsers other than Safari can't decode HEIC natively — convert in-browser.
      self.setBusyDrop(true, 'Converting HEIC photo…');
      return loadScript(HEIC2ANY_JS).then(function () {
        return window.heic2any({ blob: file, toType: 'image/jpeg', quality: 0.95 });
      }).then(function (out) {
        var blob = Array.isArray(out) ? out[0] : out;
        url = URL.createObjectURL(blob);
        return loadImage(url);
      }).catch(function () {
        throw new Error('We couldn’t convert that HEIC photo. On iPhone, choose “Most Compatible” or export as JPG.');
      });
    }).then(function (img) {
      if (self.objectUrl) URL.revokeObjectURL(self.objectUrl);
      self.objectUrl = url;
      self.image = img;
      self.fileName = file.name || 'upload';
      self.el.drop.classList.add('has-file');
      self.setBusyDrop(false, self.fileName);
      self.el.dropMeta.textContent = img.naturalWidth + ' × ' + img.naturalHeight + ' px · click or drop to replace';
      return self.openCropper(url);
    }).catch(function (err) {
      self.setBusyDrop(false, self.image ? self.fileName : 'Drag & drop or choose a file');
      self.showError(err && err.message ? err.message : 'Something went wrong loading that image.');
    }).then(function () {
      self.el.upload.value = ''; // allow re-selecting the same file
    });
  };

  CustomSign.prototype.openCropper = function (url) {
    var self = this, el = this.el;
    return ensureCropper().then(function (Cropper) {
      if (self.cropper) { self.cropper.destroy(); self.cropper = null; }
      el.editor.hidden = false;
      el.cropImg.src = url;
      return new Promise(function (resolve) {
        self.cropper = new Cropper(el.cropImg, {
          aspectRatio: self.aspect(),
          viewMode: 1,
          dragMode: 'move',
          autoCropArea: 1,
          checkOrientation: false,  // modern browsers already apply EXIF orientation
          responsive: true,
          restore: false,
          background: false,
          guides: true,
          center: true,
          movable: true,
          zoomable: true,
          zoomOnTouch: true,
          zoomOnWheel: true,
          wheelZoomRatio: 0.08,
          cropBoxMovable: true,
          cropBoxResizable: true,
          toggleDragModeOnDblclick: false,
          minCropBoxWidth: 40,
          ready: function () {
            self.syncZoom();
            self.renderPreview();
            self.updateQuality();
            self.updateSubmit();
            el.sign.classList.add('has-image');
            if (window.matchMedia('(max-width: 899px)').matches) {
              el.editor.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            self.root.dispatchEvent(new CustomEvent('custom-sign:ready', { bubbles: true }));
            resolve();
          },
          crop: function () { self.schedulePreview(); },
          zoom: function (e) {
            // Don't allow zooming out beyond "fit"; keep slider in sync.
            if (e.detail.ratio < self.baseRatio * 0.999 && e.detail.ratio < e.detail.oldRatio) { e.preventDefault(); return; }
            if (el.zoom) el.zoom.value = Math.min(parseFloat(el.zoom.max), e.detail.ratio / self.baseRatio).toFixed(2);
          }
        });
      });
    });
  };

  CustomSign.prototype.syncZoom = function () {
    if (!this.cropper || !this.image) return;
    var cd = this.cropper.getCanvasData();
    // base = "fit" ratio after reset; recompute from displayed width vs natural width
    var ratio = cd.width / cd.naturalWidth;
    var container = this.cropper.getContainerData();
    var fit = Math.min(container.width / cd.naturalWidth, container.height / cd.naturalHeight);
    this.baseRatio = fit || ratio || 1;
    if (this.el.zoom) this.el.zoom.value = Math.max(1, ratio / this.baseRatio).toFixed(2);
  };

  CustomSign.prototype.schedulePreview = function () {
    var self = this;
    if (this.raf) return;
    this.raf = requestAnimationFrame(function () {
      self.raf = 0;
      self.renderPreview();
      self.updateQuality();
    });
  };

  /** Draw the current crop into the on-wall sign canvas */
  CustomSign.prototype.renderPreview = function () {
    var c = this.el.preview, d = this.printDims();
    var long = 900, pw, ph;
    if (d.w >= d.h) { pw = long; ph = Math.round(long * d.h / d.w); } else { ph = long; pw = Math.round(long * d.w / d.h); }
    if (c.width !== pw) c.width = pw;
    if (c.height !== ph) c.height = ph;
    var ctx = c.getContext('2d');
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, pw, ph);
    if (!this.cropper || !this.image) return;
    var r = this.cropper.getData();
    if (!r.width || !r.height) return;
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(this.image, r.x, r.y, r.width, r.height, 0, 0, pw, ph);
  };

  CustomSign.prototype.currentDpi = function () {
    if (!this.cropper) return 0;
    var r = this.cropper.getData(), d = this.printDims();
    return Math.min(r.width / d.w, r.height / d.h);
  };

  CustomSign.prototype.updateQuality = function () {
    var q = this.el.quality, self = this;
    if (!this.cropper || !this.image) { q.textContent = ''; return; }
    var dpi = Math.round(this.currentDpi()), label = this.sizeLabel();
    q.classList.remove('is-ok', 'is-low');
    if (dpi < this.minDpi) {
      q.classList.add('is-low');
      q.textContent = 'Low resolution: about ' + dpi + ' DPI at ' + label + '. It may print soft or pixelated — try a smaller size, zoom out, or upload a larger image.';
    } else if (dpi < this.goodDpi) {
      q.classList.add('is-ok');
      q.textContent = 'Good resolution: about ' + dpi + ' DPI at ' + label + '.';
    } else {
      q.textContent = 'Great resolution: about ' + dpi + ' DPI at ' + label + '.';
    }
    // Flag sizes that can't reach min DPI even with the largest possible crop
    var W = this.image.naturalWidth, H = this.image.naturalHeight;
    this.el.sizes.forEach(function (b) {
      var p = self.printDims(b), a = p.w / p.h;
      var cw = (W / H > a) ? H * a : W;
      b.classList.toggle('is-low', cw / p.w < self.minDpi);
    });
  };

  CustomSign.prototype.updateSubmit = function () {
    var ready = !!(this.cropper && this.image) && !this.busy;
    this.el.submit.disabled = !ready;
    if (!this.busy) this.el.submitText.textContent = (this.cropper && this.image) ? 'Add to cart' : 'Upload an image to continue';
  };

  /**
   * Pixel size for the export at the print aspect:
   *   target = print size × exportDpi (150) → 18x24: 2700x3600 · 30x40: 4500x6000 · 40x60: 6000x9000
   *   never above the cropped source pixels (no upscaling)
   *   desktop: long side ≤ maxSide (≤ 9000 px, ~54 MP)
   *   iOS/iPadOS/Android/mobile: area ≤ 16.7 MP (iOS canvas limit) → 3:4 ≈ 3547x4729, 2:3 ≈ 3344x5016
   */
  CustomSign.prototype.exportPlan = function () {
    var d = this.printDims(), a = d.w / d.h, r = this.cropper.getData(true);
    var cropLong = Math.max(r.width, r.height);
    var targetLong = Math.round(Math.max(d.w, d.h) * this.exportDpi);
    var long = Math.min(targetLong, cropLong, this.maxSide), limitedBy = 'target';
    if (long === cropLong && cropLong < targetLong) limitedBy = 'source';
    else if (long === this.maxSide && this.maxSide < targetLong) limitedBy = 'max-side';
    if (this.mobileCanvas) {
      var ratio = a >= 1 ? a : 1 / a; // long / short
      var mobileLong = Math.floor(Math.sqrt(MOBILE_PLAN_PIXELS * ratio));
      if (mobileLong < long) { long = mobileLong; limitedBy = 'device'; }
    }
    return { d: d, a: a, crop: r, long: Math.max(1, Math.floor(long)), targetLong: targetLong, limitedBy: limitedBy };
  };

  function dimsFor(long, a, maxPixels) {
    var W, H;
    if (a >= 1) { W = long; H = Math.max(1, Math.round(long / a)); } else { H = long; W = Math.max(1, Math.round(long * a)); }
    while (maxPixels && W * H > maxPixels && long > 1) { // rounding guard
      long -= 1;
      if (a >= 1) { W = long; H = Math.max(1, Math.round(long / a)); } else { H = long; W = Math.max(1, Math.round(long * a)); }
    }
    return { W: W, H: H, long: long };
  }

  /** Render the crop at print aspect (adaptive size, see exportPlan), JPEG ≤ 19 MB */
  CustomSign.prototype.exportFile = function () {
    var self = this, plan = this.exportPlan(), d = plan.d, a = plan.a, r = plan.crop;
    var maxPixels = this.mobileCanvas ? MOBILE_PLAN_PIXELS : 0;
    var startQ = Math.min(Math.max(this.quality, 0.5), 1);
    var qualities = [startQ].concat(QUALITY_STEPS.filter(function (q) { return q < startQ - 0.001; }));
    var name = 'your-design-' + slug(d.w + 'x' + d.h) + '-' + this.orientation + '-' +
      slug((this.fileName || 'image').replace(/\.[^.]+$/, '')).slice(0, 40) + '.jpg';
    var log = []; // attempts, for debugging / analytics
    var reduced = { canvas: false, bytes: false };

    function finalError(msg) { var e = new Error(msg); e.final = true; return e; }
    function release(c) { try { c.width = 0; c.height = 0; } catch (e) { /* noop */ } } // free iOS canvas memory early

    function render(long) {
      var dims = dimsFor(long, a, maxPixels), canvas = null;
      try {
        // Draw the crop straight from the decoded <img> into the output canvas. (Cropper's getCroppedCanvas first
        // copies the WHOLE source into a full-resolution canvas, e.g. 73 MP for a 7000x10500 photo, which is over
        // iOS's 16.7 MP canvas limit and doubles memory everywhere.) Rotation/flip aren't used, so this is equivalent.
        canvas = document.createElement('canvas');
        canvas.width = dims.W; canvas.height = dims.H;
        if (canvas.width !== dims.W || canvas.height !== dims.H) throw new Error('canvas size');
        var ctx = canvas.getContext('2d');
        if (!ctx) throw new Error('no 2d context');
        ctx.fillStyle = '#fff';
        ctx.fillRect(0, 0, dims.W, dims.H);
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        var img = self.image, iw = img.naturalWidth, ih = img.naturalHeight;
        // clamp the source rect to the image (viewMode 1 keeps it inside, but be safe) and map to the canvas
        var sx = Math.max(0, r.x), sy = Math.max(0, r.y);
        var ex = Math.min(iw, r.x + r.width), ey = Math.min(ih, r.y + r.height);
        if (ex > sx && ey > sy) {
          var kx = dims.W / r.width, ky = dims.H / r.height;
          ctx.drawImage(img, sx, sy, ex - sx, ey - sy,
            (sx - r.x) * kx, (sy - r.y) * ky, (ex - sx) * kx, (ey - sy) * ky);
        }
      } catch (e) {
        if (canvas) release(canvas);
        return Promise.reject(e);
      }
      return Promise.resolve({ canvas: canvas, dims: dims });
    }

    // Canvas creation / encoding failed (iOS returns null from toBlob or throws when over its limits): shrink & retry.
    function renderAndEncode(long, qi, firstSize) {
      return render(long).then(function (res) {
        var canvas = res.canvas, dims = res.dims;
        function encode(qi2) {
          var q = qualities[qi2];
          var p;
          try { p = canvasToBlob(canvas, 'image/jpeg', q); } catch (e) { p = Promise.reject(e); }
          return p.then(function (blob) {
            if (!blob || !blob.size) throw new Error('empty blob');
            log.push({ w: dims.W, h: dims.H, q: q, bytes: blob.size });
            if (firstSize == null) firstSize = blob.size;
            if (blob.size <= MAX_UPLOAD_BYTES) {
              var out = { blob: blob, width: canvas.width, height: canvas.height, quality: q };
              release(canvas);
              return out;
            }
            if (qi2 + 1 < qualities.length) return encode(qi2 + 1);
            // Still too big at the lowest quality: scale down (area ∝ bytes) and start again at full quality.
            reduced.bytes = true;
            release(canvas);
            var f = Math.min(0.9, Math.sqrt(MAX_UPLOAD_BYTES / firstSize) * 0.95);
            var next = Math.floor(dims.long * f);
            if (next < MIN_EXPORT_SIDE) throw finalError('Your image is too large to upload. Please try a smaller file.');
            return renderAndEncode(next, 0, null);
          }, function (err) {
            release(canvas);
            throw { encodeFailed: true, err: err };
          });
        }
        return encode(qi);
      }).catch(function (e) {
        if (e && e.final) throw e; // already handled further down the chain
        log.push({ long: long, error: 'canvas/encode failed at long side ' + long + ': ' + ((e && (e.err || e).message) || e) });
        reduced.canvas = true;
        var next = Math.floor(long * RETRY_SCALE);
        if (next < MIN_EXPORT_SIDE) throw finalError('Your browser couldn’t prepare the file. Try a smaller image or a different browser.');
        return renderAndEncode(next, qi, null);
      });
    }

    return renderAndEncode(plan.long, 0, null).then(function (res) {
      var blob = res.blob, file;
      try { file = new File([blob], name, { type: 'image/jpeg', lastModified: Date.now() }); }
      catch (e) { file = blob; file.name = name; }
      var limitedBy = reduced.canvas ? 'device' : reduced.bytes ? 'file-size' : plan.limitedBy;
      return { file: file, blob: blob, name: name, width: res.width, height: res.height, crop: r, quality: res.quality,
        dpi: Math.round(self.currentDpi()), fileDpi: Math.round(Math.min(res.width / d.w, res.height / d.h)),
        targetDpi: self.exportDpi, limitedBy: limitedBy, mobileCanvas: self.mobileCanvas, attempts: log };
    });
  };

  CustomSign.prototype.setBusy = function (on, text) {
    this.busy = on;
    this.el.submit.setAttribute('aria-busy', on ? 'true' : 'false');
    if (text) this.el.submitText.textContent = text;
    this.el.submit.disabled = on || !(this.cropper && this.image);
    if (!on) this.updateSubmit();
  };

  CustomSign.prototype.addToCart = function () {
    var self = this, el = this.el;
    this.showError('');
    if (!this.cropper || !this.image) { this.showError('Please upload an image first.'); return; }
    if (this.busy) return;
    this.setBusy(true, 'Preparing your file…');

    this.exportFile().then(function (out) {
      var d = self.printDims();
      el.propSize.value = d.w + ' x ' + d.h + ' in (' + self.orientation + ')';
      el.propFilename.value = self.fileName;
      // e.g. "160 DPI source · 150 DPI file (4500 x 6000 px)"  /  "107 DPI source · 107 DPI file (4286 x 6429 px)"
      //      "200 DPI source · 84 DPI file (3344 x 5016 px, reduced for this device)"
      var note = { device: ', reduced for this device', 'file-size': ', reduced to fit 19 MB', 'max-side': ', max export size' }[out.limitedBy] || '';
      el.propDpi.value = out.dpi + ' DPI source · ' + out.fileDpi + ' DPI file (' + out.width + ' x ' + out.height + ' px' + note + ')';
      el.propCrop.value = [out.crop.x, out.crop.y, out.crop.width, out.crop.height].join(',') +
        ' of ' + self.image.naturalWidth + 'x' + self.image.naturalHeight + ' → ' + out.width + 'x' + out.height + 'px';

      var attached = false;
      try {
        var dt = new DataTransfer();
        dt.items.add(out.file);
        el.file.files = dt.files;
        attached = el.file.files.length === 1;
      } catch (e) { attached = false; }

      self.lastExport = out;
      self.root.__csLastExport = out;
      self.root.dispatchEvent(new CustomEvent('custom-sign:exported', { bubbles: true, detail: out }));

      var fd = new FormData(self.form);
      if (!attached) fd.set('properties[Your Design]', out.file, out.name);

      self.setBusy(true, 'Uploading your design…');
      return fetch(self.cartAddUrl.replace(/\/$/, '') + '.js', {
        method: 'POST',
        body: fd, // multipart/form-data (boundary set by the browser)
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin'
      }).then(function (res) {
        if (res.ok) {
          self.setBusy(true, 'Added — opening cart…');
          window.location.href = self.cartUrl;
          return;
        }
        return res.json().catch(function () { return {}; }).then(function (j) {
          throw new Error(j.description || j.message || 'Could not add to cart (' + res.status + ').');
        });
      }, function () {
        // Network/JS failure: fall back to a native multipart form post (redirects to /cart).
        if (attached) { self.form.submit(); return; }
        throw new Error('Upload failed. Please check your connection and try again.');
      });
    }).catch(function (err) {
      self.setBusy(false);
      self.showError(err && err.message ? err.message : 'Something went wrong. Please try again.');
    });
  };

  function init() {
    $$('[data-custom-sign]').forEach(function (root) {
      if (!root.__customSign) root.__customSign = new CustomSign(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init); // theme editor
})();